import type { ValidationError } from '../../vendors/errors/validation-error'
import type { InputProps, InputRef } from 'antd'
import type { LegacyRef } from 'react'

import { Col, Form, Row, Typography, Input } from 'antd'
import { forwardRef } from 'react'
import InputMask from 'react-input-mask'

import { PushType } from '../../../domain/push-type.enum'

interface PinacleInformationProps {
  validationError?: Partial<ValidationError>
  fundingType?: PushType
}

export function PinnacleInformation({
  validationError,
  fundingType
}: PinacleInformationProps): JSX.Element {
  return (
    <Col span={6} className='p-4 rounded-lg border'>
      <Row>
        <Typography.Title
          level={5}
          className='font-lato tracking-wide uppercase text-[9.5px] font-semibold text-lucent-gray mb-2'
        >
          lucent pinnacle Account
        </Typography.Title>
      </Row>

      <Form.Item
        name='pinnacle_routing_number'
        label={
          <span className='font-lato tracking-wide uppercase text-[9.5px] font-semibold text-lucent-gray'>
            Pinnacle Routing Number
          </span>
        }
        validateStatus={validationError?.issues?.pinnacle_routing_number ? 'error' : undefined}
        help={validationError?.issues?.pinnacle_routing_number}
        required={fundingType === PushType.Pull}
      >
        <MaskedInput
          mask='999999999'
          size='middle'
          className='w-full rounded-md'
          placeholder={fundingType === PushType.FBB ? '—' : 'E.g. 800107535684'}
          disabled={fundingType === PushType.FBB}
        />
      </Form.Item>
      <Form.Item
        name='pinnacle_account_number'
        label={
          <span className='font-lato tracking-wide uppercase text-[9.5px] font-semibold text-lucent-gray'>
            Pinnacle Account Number
          </span>
        }
        validateStatus={validationError?.issues?.pinnacle_account_number ? 'error' : undefined}
        help={validationError?.issues?.pinnacle_account_number}
        required={fundingType === PushType.Pull}
      >
        <Input
          size='middle'
          className='w-full rounded-md'
          placeholder={fundingType === PushType.FBB ? '—' : 'E.g. 800107535684'}
          disabled={fundingType === PushType.FBB}
        />
      </Form.Item>
    </Col>
  )
}

interface CustomMaskedInputProps {
  mask?: string
  size?: 'large' | 'middle' | 'small'
  className?: string
  placeholder?: string
  disabled?: boolean
}

const MaskedInput = forwardRef<unknown, CustomMaskedInputProps>(function MaskedInput(props, ref) {
  const { mask = '', size, className, placeholder, disabled, ...restProps } = props
  return (
    <InputMask mask={mask} {...restProps} disabled={disabled ?? false}>
      {(inputProps: InputProps) => (
        <Input
          {...inputProps}
          ref={ref as LegacyRef<InputRef>}
          size={size}
          className={className}
          placeholder={placeholder}
          disabled={disabled ?? false}
          // size='middle'
          // className='w-full rounded-md'
          // placeholder={fundingType === PushType.Pull ? 'E.g. 702144500' : '—'}
          // disabled={fundingType !== PushType.Pull}
        />
      )}
    </InputMask>
  )
})
